import { render } from "./mobile.vue?vue&type=template&id=c5ec8cd8&ts=true"
import script from "./mobile.vue?vue&type=script&lang=ts"
export * from "./mobile.vue?vue&type=script&lang=ts"

import "./mobile.vue?vue&type=style&index=0&id=c5ec8cd8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__